import { render, staticRenderFns } from "./ShowCertificates.vue?vue&type=template&id=9c5e92da"
import script from "./ShowCertificates.vue?vue&type=script&lang=js"
export * from "./ShowCertificates.vue?vue&type=script&lang=js"
import style0 from "./ShowCertificates.vue?vue&type=style&index=0&id=9c5e92da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports